// extracted by mini-css-extract-plugin
export default {"editSelectionListForm":"editSelectionListForm_editSelectionListForm__3n7zs","buttonsGroup":"editSelectionListForm_buttonsGroup__bFmSw"};